import React from 'react'

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://github.com/adx69" className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-github"></i>
            </a>
            <a href="https://telegram.me/adx69" className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-telegram"></i>
            </a>
            <a href="https://instagram.com/adx.py" className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-instagram"></i>
            </a>
        </div>
    )
}

export default Social
